// The administration screens' `tab` search parameter (`RPM-063`, `J-291`; `01-DOCTRINE.md` AR-2).
// An unknown value falls back to the details rather than refusing the address.
import { z } from "zod";

export const historyTabSearchSchema = z.object({
  tab: z.enum(["details", "history"]).optional().catch(undefined),
});
